"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillSelectByElement = exports.fillSelect = exports.convertFormToJSON = void 0;
var jquery_1 = __importDefault(require("jquery"));
function convertFormToJSON($form) {
    return $form
        .serializeArray()
        .reduce(function (json, _a) {
        var name = _a.name, value = _a.value;
        if (json[name]) {
            if (Array.isArray(json[name])) {
                json[name].push(value);
            }
            else {
                json[name] = [json[name], value];
            }
        }
        else {
            json[name] = value;
        }
        return json;
    }, {});
}
exports.convertFormToJSON = convertFormToJSON;
function fillSelect(selector, items) {
    var $select = (0, jquery_1.default)(selector);
    fillSelectByElement($select, items);
}
exports.fillSelect = fillSelect;
function fillSelectByElement($select, items) {
    $select.empty();
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        $select.append((0, jquery_1.default)("<option value=\"".concat(item.value, "\">").concat(item.title, "</option>")));
    }
}
exports.fillSelectByElement = fillSelectByElement;
